const apriPermalinkAssistente = (permalink, ufficio) => window.open(
  `${window.config.urlAssistente}/permalink/Contenuto?aliasArea=730&permalink=${permalink}&codiceUfficio=${ufficio}`,
  '_blank',
);

export default apriPermalinkAssistente;
